import { render, staticRenderFns } from "./taxPayerContent.vue?vue&type=template&id=5bdbf02a&scoped=true&"
import script from "./taxPayerContent.vue?vue&type=script&lang=js&"
export * from "./taxPayerContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bdbf02a",
  null
  
)

export default component.exports